module.exports = __webpack_public_path__ + "img/noun_profile.51f547de.svg";